export default "__VITE_ASSET__Cjc5ni3t__"